
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static/[...slug]",
      function () {
        return require("private-next-pages/static/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static/[...slug]"])
      });
    }
  